import {
  displayFormattedNumberWithPrefixAndMultiplier,
  displayString
} from '../format';

import { UNIT_STRINGS } from '../appConstants';

export const DerStatusSchema = {
  derId: {
    // no toDisplayString, since it will not be displayed.
  },
  alarmStatus: {
    // no toDisplayString, since it will not be displayed.
  },
  readingTime: {
    // no toDisplayString, since it will not be displayed.
  },
  genConnectStatus: {
    toDisplayString: displayString
  },
  inverterStatus: {
    toDisplayString: displayString
  },
  localControlModeStatus: {
    toDisplayString: displayString
  },
  manufacturerStatus: {
    toDisplayString: displayString
  },
  operationalModeStatus: {
    // seconds
    toDisplayString: displayString
  },
  storageModeStatus: {
    // seconds
    toDisplayString: displayString
  },
  storConnectStatus: {
    toDisplayString: displayString
  },
  stateOfChargeStatus: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  }
};
